module.exports = __webpack_public_path__ + "static/img/wx_checked.5abb890b.png";